import React from 'react';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import { Translate as TranslateIcon } from '@mui/icons-material';
import {
  isEnglishMarketCountry,
  primaryCountryFromCountriesField,
} from '../utils/skuTitleTranslationUtils';

function SkuTitleWithTranslate({
  title,
  country,
  countriesField,
  getDisplayTitle,
  isTranslationActive,
  isTranslatingTitle,
  onToggleTranslate,
  onTitleClick,
  stopPropagation = true,
}) {
  const resolvedCountry = country || primaryCountryFromCountriesField(countriesField);
  const display = getDisplayTitle(title, resolvedCountry);
  const active = isTranslationActive(title, resolvedCountry);
  const loading = isTranslatingTitle(title, resolvedCountry);
  const showOriginal = active && display && display !== title;
  const hideTranslate = isEnglishMarketCountry(resolvedCountry);

  const handleToggle = (e) => {
    if (stopPropagation) e.stopPropagation();
    onToggleTranslate(title, resolvedCountry);
  };

  const titleInner = (
    <Box
      component="span"
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...(onTitleClick
          ? {
              color: 'primary.main',
              cursor: 'pointer',
              '&:hover': { textDecoration: 'underline' },
            }
          : {}),
      }}
      onClick={
        onTitleClick
          ? (e) => {
              if (stopPropagation) e.stopPropagation();
              onTitleClick();
            }
          : undefined
      }
    >
      {display}
    </Box>
  );

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.25,
        maxWidth: '100%',
        verticalAlign: 'middle',
      }}
    >
      <Tooltip title={showOriginal ? title : ''} disableHoverListener={!showOriginal}>
        {titleInner}
      </Tooltip>
      {!hideTranslate && (
        <Tooltip title={active ? 'Show original title' : 'Translate to English'}>
          <span>
            <IconButton
              size="small"
              onClick={handleToggle}
              disabled={loading || !title}
              sx={{
                p: 0.2,
                color: active ? 'primary.main' : 'action.active',
              }}
              aria-label={active ? 'Show original SKU title' : 'Translate SKU title to English'}
            >
              {loading ? (
                <CircularProgress size={14} />
              ) : (
                <TranslateIcon sx={{ fontSize: 15 }} />
              )}
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
}

export default SkuTitleWithTranslate;
